export interface BemDecl {
    block: string;
    elem?: string;
    mods?: { [modName: string]: string | boolean };
}

export class Bem {
    /**
     * Приводит переданную строку в bem нотацию для именования блоков, элементов и тд
     * @param {String} text
     * @returns {String}
     */
    static beminize(text: string): string {
        return (
            text
                // [^C]amel | cas[eC]apsed | mixed[_V]alues[_W]ithCamels | Extra---[-D]ashes--here
                .replace(/(^|[a-z_\-])([A-Z])/g, function(origin: string, a: string, b: string): string {
                    if (a === '_') {
                        a = '-';
                    }

                    if (a && a !== '-') {
                        a = a + '-';
                    }

                    return a + b.toLowerCase();
                })
                // [Ca]mel и case[Ca]psed
                .replace(/([A-Z])([a-z])/g, function(origin: string, a: string, b: string): string {
                    return a.toLowerCase() + '_' + b;
                })
                .replace(/_/g, '-')
                .toLowerCase()
        );
    }

    static cls(block: string, elem?: string, mods?: { [modName: string]: string | boolean | undefined }): string;

    static cls(block: string, elem?: string): string;

    static cls(decl: BemDecl): string;

    static cls(decl: BemDecl | string, elem?: string, mods?: { [modName: string]: string | boolean }): string {
        return typeof decl === 'string' ? Bem.getCls({ block: decl, elem, mods }) : Bem.getCls(decl);
    }

    private static getCls(decl: BemDecl): string {
        const { block, elem, mods } = decl;
        const baseClass: string = elem ? `${block}__${elem}` : block;

        if (!mods) {
            return baseClass;
        }

        const modsClasses = Object.keys(mods).reduce((res, mod) => {
            if (mods[mod] === true) {
                return `${res} ${baseClass}_${mod}`;
            } else if (mods[mod] === '' || mods[mod] === false) {
                return res;
            } else {
                return `${res} ${baseClass}_${mod}_${mods[mod]}`;
            }
        }, '');

        return `${baseClass}${modsClasses}`;
    }
}
